<template>
  <div>
    <Pane :bottom="0" :showRemarks="false">
      <a-tabs
        :tabBarStyle="{
                    margin: '0',
                  }"
        v-model="active"
      >
        <a-tab-pane key="tab1" tab="招待费台账"></a-tab-pane>
      </a-tabs>
    </Pane>
    <a-card v-show="active === 'tab1'" class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <a-range-picker v-model="form.date" />
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>
          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
              <a-button @click="download" type="primary">导出</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        :columns="[
          {
            key: 'deptName',
            title: '部门',
            dataIndex: 'deptName',
          },
          ...titleList,
        ]"
        :dataSource="list"
        :loading="loading"
        :pagination="false"
      >
      </a-table>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import { fetchApplyList } from "@/api/oa/entertain";
import { downloadByHtml } from "@/utils/xlsx";
import moment from "moment";
export default {
  name: "entertainList",
  mixins: [watermark],

  data() {
    return {
      active: "tab1",
      form: {},
      loading: false,
      titleList: [],
      list: [],
    };
  },

  mounted() {
    const year = moment().year();
    const month = moment().month();

    let year2 = year;
    let month2 = month + 1;

    if (11 === month) {
      year2 = year + 1;
      month2 = 0;
    }

    this.form = {
      date: [
        moment([year, month, 1]),
        moment([year2, month2, 1]).subtract(1, "days"),
      ],
    };

    this.getList();
  },

  methods: {
    getList() {
      const { date } = this.form;

      let startTime, endTime;
      if (Array.isArray(date) && date.length === 2) {
        startTime = date[0].format("YYYY-MM-DD");
        endTime = date[1].format("YYYY-MM-DD");
      }

      this.loading = true;
      fetchApplyList({
        startTime,
        endTime,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.titleList) && Array.isArray(res.dataList)) {
            // 从 titleList 中提取酒水产品名称
            const standaloneTitles = [];
            const productTitles = [];
            for (const item of res.titleList) {
              if (item.endsWith("(数量)")) {
                const name = item.replace("(数量)", "");
                let p = productTitles.find((x) => x.name === name);
                if (!p) {
                  p = { name, hasQty: true, hasAmt: false };
                  productTitles.push(p);
                } else {
                  p.hasQty = true;
                }
              } else if (item.endsWith("(金额)")) {
                const name = item.replace("(金额)", "");
                let p = productTitles.find((x) => x.name === name);
                if (!p) {
                  p = { name, hasQty: false, hasAmt: true };
                  productTitles.push(p);
                } else {
                  p.hasAmt = true;
                }
              } else {
                standaloneTitles.push(item);
              }
            }

            this.titleList = [
              ...standaloneTitles.map((item) => ({
                title: item,
                children: [
                  { title: "金额(元)", dataIndex: item, align: "center" },
                ],
              })),
              {
                title: "酒水",
                children: productTitles.map((p) => ({
                  title: p.name,
                  children: [
                    ...(p.hasQty
                      ? [
                          {
                            title: "数量",
                            dataIndex: p.name + "(数量)",
                            align: "center",
                          },
                        ]
                      : []),
                    ...(p.hasAmt
                      ? [
                          {
                            title: "金额(元)",
                            dataIndex: p.name + "(金额)",
                            align: "center",
                          },
                        ]
                      : []),
                  ],
                })),
              },
            ];

            this.list = res.dataList
              .filter((item) => Array.isArray(item.dataList))
              .map((item) => {
                const obj = {};
                for (let i = 0; i < res.titleList.length; i++) {
                  const title = res.titleList[i];
                  const values = item.dataList[i];
                  if (title.includes("数量")) {
                    obj[title] = values.quantity;
                  } else {
                    obj[title] = values.totalPrice;
                  }
                }

                return {
                  deptName: item.deptName,
                  deptId: item.deptId,
                  ...obj,
                };
              });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    query() {
      this.getList();
    },
    reset() {
      this.form = {};
      this.getList();
    },

    download() {
      downloadByHtml(document.getElementsByTagName("table")[0], "招待费台账");
    },
  },
};
</script>
